<template>
    <b-form @submit.prevent="emitPermissions" autocomplete="off">
        <b-row
            v-for="(item, index) in visiblePermissions"
            :key="index"
            class="m-0 p-2">
            <b-form-group
                :label="`<strong>${index}</strong>`"
                :label-cols="3"
                class="w-100">
                <b-form-checkbox-group v-model="checkedValues">
                    <template v-for="permission in item">
                        <b-form-checkbox
                            :key="permission.uuid"
                            :value="permission.uuid"
                            :disabled="isDisabledPermission(permission.uuid)"
                            @change="permissionCheckboxChanged($event, permission.name, index)"
                            class="w-25">
                            {{ permission.description }}
                        </b-form-checkbox>
                    </template>
                </b-form-checkbox-group>
            </b-form-group>
        </b-row>
        <b-row>
            <slot></slot>
        </b-row>
    </b-form>
</template>

<script>
    import {isAllPermission} from '@/helpers/permission-helper';

    export default {
        name: "permissions-check-list",
        props: [
            'allPermissions',
            'initialPermissions',
            'disabledPermissions'
        ],
        data: function () {
            return {
                visiblePermissions: this.allPermissions,
                checkedValues: this.initialPermissions.map((permission) => (permission.uuid))
            }
        },
        methods: {
            emitPermissions() {
                this.$emit('emit-permission-uuids', this.checkedValues);
            },
            isDisabledPermission(permissionUuid) {
                return (!!this.disabledPermissions.find((permission) => (permission.uuid === permissionUuid)));
            },
            permissionCheckboxChanged(permissionUuid, permissionName, permissionCategory) {
                if (isAllPermission(permissionName)) {
                    if (!!permissionUuid) {
                        let permission = this.allPermissions[permissionCategory].find((permission) => (permission.uuid === permissionUuid));
                        let array = [];
                        array.push(permission);
                        this.visiblePermissions = {};
                        this.visiblePermissions[permissionCategory] = array;
                    } else {
                        this.visiblePermissions = this.allPermissions;
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>